import { render, staticRenderFns } from "./PhotoBookImage.vue?vue&type=template&id=d4cea290&scoped=true"
import script from "./PhotoBookImage.vue?vue&type=script&lang=js"
export * from "./PhotoBookImage.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookImage.vue?vue&type=style&index=0&id=d4cea290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cea290",
  null
  
)

export default component.exports